var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/progress-bar/progress-bar.tsx";
import React from 'react';

/** A horizontal meter filled to the given percentage. */
const ProgressBar = _ref => {
  let {
    progress
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "h-2.5 w-full rounded-full bg-gray-300 dark:bg-primary-800 overflow-hidden",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-full bg-secondary-500",
    style: {
      width: "".concat(Math.floor(progress * 100), "%")
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 5
    }
  }));
};

export default ProgressBar;